module.exports = __webpack_public_path__ + "static/media/08.5b2ad761.jpg";